/** @jsx jsx */
import React, { useEffect, useMemo, useRef } from 'react'
import { jsx } from 'theme-ui'
import { FlexCol, FlexCols } from '../../../styles/els'
import Paragraph from '../../paragraph'
import Card from '../../card'
import VideoWrapper from '../../video-wrapper'
import { resolveButtons } from '../../../lib/helpers'

const VideoText = (props) => {
  const { heading, text, video, sectionColor, align, buttons } = props

  const reverse = align === 'right'

  return (
    <FlexCols
      space={[4, 7]}
      sx={{
        py: 8,
        alignItems: 'center',
        flexDirection: reverse ? 'row-reverse' : null,
      }}
    >
      <FlexCol base={[1, null, null, null, 2]}>
        <div
          sx={{
            maxWidth: '640px',
            pl: reverse ? [0, null, null, null, 8] : null,
            pr: reverse ? null : [0, null, null, null, 8],
          }}
        >
          <Paragraph
            heading={heading}
            text={text}
            hTier={4}
            tTier={2}
            buttons={resolveButtons(buttons)}
          />
        </div>
      </FlexCol>
      <FlexCol base={[1, null, null, null, 2]}>
        {video && (
          <Card minimal={true} color={sectionColor}>
            <VideoWrapper embed={video} byPassSplash={true} />
          </Card>
        )}
      </FlexCol>
    </FlexCols>
  )
}

export default VideoText
